export default {
  buttons: {
    save: 'Tallenna',
  },
  error_messages: {
    product_unavailable: 'Loppunut!',
  },
};
